import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { TabPanel } from '../TabPanel/TabPanel';
import { LabelTitle } from '../CustomComponent/CustomComponents';
import * as s from './TabsPayment.style';
import { globalTheme } from '@next-common/mui';
export const TabsPayment = ({ paymentMethods = [], }) => {
    var _a;
    const [activePanel, setActivePanel] = useState(0);
    const newPayment = Array.isArray(paymentMethods)
        ? paymentMethods.sort((p1, p2) => p1.monthlyPayment > p2.monthlyPayment
            ? 1
            : p1.monthlyPayment < p2.monthlyPayment
                ? -1
                : 0)
        : [];
    const theme = globalTheme();
    const fullscreen = theme.breakpoints.down('sm');
    useEffect(() => {
        newPayment.map((method, index) => {
            if (method.monthlyPayment === 4)
                setActivePanel(index);
        });
    }, []);
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const label = (timesPayment, name, index) => {
        return (React.createElement(Box, null,
            LabelTitle(name.toUpperCase()),
            React.createElement(Box, { component: 'p', sx: index === activePanel ? s.activeTab : s.nonActive },
                "Payer en ",
                timesPayment,
                "x")));
    };
    function isSoloKlarna(name = '', length) {
        return (name === null || name === void 0 ? void 0 : name.toUpperCase().includes('KLARNA')) && length === 1;
    }
    const handleChange = (
    // eslint-disable-next-line @typescript-eslint/ban-types
    event, newValue) => {
        setActivePanel(newValue);
    };
    return (React.createElement(Box, null,
        !isSoloKlarna((_a = paymentMethods[0]) === null || _a === void 0 ? void 0 : _a.name, paymentMethods.length) && (React.createElement(Box, { sx: s.tabsContainer },
            React.createElement(Tabs, { sx: s.tabs, value: activePanel, onChange: handleChange, "aria-label": "centered tabs", variant: 'fullWidth' }, newPayment.map((paymentMethod, index) => {
                return (React.createElement(Tab, Object.assign({ key: index, sx: {
                        minWidth: fullscreen ? '80px' : '100px',
                        height: '64px',
                        whiteSpace: 'unset',
                        lineHeight: 1,
                        fontSize: fullscreen ? '12px' : '14px',
                    }, label: label(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.monthlyPayment, paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name, index) }, a11yProps(index))));
            })))),
        newPayment.map((paymentMethod, index) => {
            return (React.createElement(TabPanel, { key: (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.name) + index, index: index, value: activePanel, paymentMethod: paymentMethod }));
        })));
};
